'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _reactAddonsPureRenderMixin = require('react-addons-pure-render-mixin');

var _reactAddonsPureRenderMixin2 = _interopRequireDefault(_reactAddonsPureRenderMixin);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactDom = require('react-dom');

var _UIAbstractPopup = require('./UIAbstractPopup');

var _UIAbstractPopup2 = _interopRequireDefault(_UIAbstractPopup);

var _UIPopoverContent = require('./UIPopoverContent');

var _UIPopoverContent2 = _interopRequireDefault(_UIPopoverContent);

var _UIPopoverArrow = require('./UIPopoverArrow');

var _UIPopoverArrow2 = _interopRequireDefault(_UIPopoverArrow);

var _PlacementConstants = require('./PlacementConstants');

var _Functions = require('../core/Functions');

var _EventHandlers = require('../core/EventHandlers');

var _SyntheticEvent = require('../core/SyntheticEvent');

var _SyntheticEvent2 = _interopRequireDefault(_SyntheticEvent);

var _Placement = require('./utils/Placement');

var _domElement = require('../utils/propTypes/domElement');

var _domElement2 = _interopRequireDefault(_domElement);

var _ModalTransitionContext = require('../context/ModalTransitionContext');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var getArrowSize = function getArrowSize(arrowSize, use) {
  if (arrowSize != null) return arrowSize;
  if (use === 'tooltip' || use === 'tooltip-danger') return 'small';
  return 'medium';
};

var getAnimateOnToggle = function getAnimateOnToggle(animateOnToggle, computedArrowSize) {
  return animateOnToggle != null ? animateOnToggle : computedArrowSize !== 'none';
};

var getPlacement = function getPlacement(placementProp, placementState) {
  return placementState || placementProp;
};

var UIPopover = _react2.default.createClass({
  displayName: 'UIPopover',

  mixins: [_reactAddonsPureRenderMixin2.default],

  propTypes: _extends({}, _UIPopoverContent2.default.propTypes, {
    addTargetClasses: _react.PropTypes.bool,
    arrowSize: _react.PropTypes.oneOf(Object.keys(_UIPopoverArrow2.default.ARROW_SIZES)),
    autoPlacement: _UIAbstractPopup2.default.propTypes.autoPlacement,
    children: _react.PropTypes.element,
    closeOnOutsideClick: _react.PropTypes.bool.isRequired,
    closeOnTargetLeave: _react.PropTypes.bool.isRequired,
    onFocusLeave: _react.PropTypes.func,
    onChangePlacement: _react.PropTypes.func,
    onOpenChange: _react.PropTypes.func,
    pinToConstraint: _UIAbstractPopup2.default.propTypes.pinToConstraint,
    pinToOutOfBoundsTarget: _UIAbstractPopup2.default.propTypes.pinToOutOfBoundsTarget,
    placement: _react.PropTypes.oneOf(_PlacementConstants.PLACEMENTS).isRequired,
    shouldCloseOnClick: _react.PropTypes.func,
    target: _domElement2.default,
    targetAttachment: _react.PropTypes.string.isRequired,
    zIndex: _react.PropTypes.number.isRequired,
    _distanceAdjustment: _react.PropTypes.number,
    _insetAdjustment: _react.PropTypes.number,
    _bodyElement: _domElement2.default,
    _useMutationObserver: _react.PropTypes.bool.isRequired
  }),

  getDefaultProps: function getDefaultProps() {
    return _extends({}, _UIPopoverContent2.default.defaultProps, {
      autoPlacement: true,
      closeOnOutsideClick: true,
      closeOnTargetLeave: false,
      _distanceAdjustment: 0,
      _insetAdjustment: 0,
      open: false,
      pinToConstraint: ['top', 'bottom'],
      pinToOutOfBoundsTarget: false,
      placement: 'top',
      targetAttachment: 'auto',
      zIndex: _UIAbstractPopup2.default.defaultProps.zIndex,
      _useMutationObserver: false
    });
  },
  getInitialState: function getInitialState() {
    return {
      closeComplete: true,
      placement: null
    };
  },
  componentDidMount: function componentDidMount() {
    var _this = this;

    this._isMounted = true;
    if (this.props.open) {
      // Delay binding to ensure that the click that opened the popover is ignored
      this._mountFrame = requestAnimationFrame(function () {
        window.addEventListener('click', _this.handleWindowClick);
        _this.startIntersectionObserver();
      });
    }
  },
  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
    // If the placement prop is reset, clear our internal override.
    if (nextProps.placement !== this.props.placement) {
      this.setState({ placement: null });
    }

    if (!nextProps.open && this.props.open && this.state.closeComplete) {
      this.setState({ closeComplete: false });
    }
  },
  componentDidUpdate: function componentDidUpdate(prevProps) {
    var open = this.props.open;

    if (open && !prevProps.open) {
      window.addEventListener('click', this.handleWindowClick);
      this.startIntersectionObserver();
    } else if (!open && prevProps.open) {
      window.removeEventListener('click', this.handleWindowClick);
      this.stopIntersectionObserver();
    }
  },
  componentWillUnmount: function componentWillUnmount() {
    this._isMounted = false;
    window.removeEventListener('click', this.handleWindowClick);
    this.stopIntersectionObserver();
    cancelAnimationFrame(this._mountFrame);
    clearTimeout(this._leaveTransitionTimeout);
  },
  startIntersectionObserver: function startIntersectionObserver() {
    var _this2 = this;

    // When closeOnTargetLeave is enabled, we use an IntersectionObserver to close the popover if
    // its target leaves the screen due to scrolling (#3856).
    if (!this.props.closeOnTargetLeave) return;

    var _window = window,
        IntersectionObserver = _window.IntersectionObserver;

    if (!IntersectionObserver) return; // No browser support (IE11)

    var targetEl = (0, _reactDom.findDOMNode)(this);
    if (!targetEl) return;

    this._intersectionObserver = new IntersectionObserver(function (entries) {
      var intersectionRatio = entries[0].intersectionRatio;

      if (intersectionRatio <= 0) {
        (0, _Functions.callIfPossible)(_this2.props.onOpenChange, (0, _SyntheticEvent2.default)(false));
      }
    });
    this._intersectionObserver.observe(targetEl);
  },
  stopIntersectionObserver: function stopIntersectionObserver() {
    if (this._intersectionObserver) {
      this._intersectionObserver.disconnect();
      this._intersectionObserver = null;
    }
  },
  handleWindowClick: function handleWindowClick(evt) {
    var _props = this.props,
        closeOnOutsideClick = _props.closeOnOutsideClick,
        onOpenChange = _props.onOpenChange,
        shouldCloseOnClick = _props.shouldCloseOnClick,
        target = _props.target;


    if (shouldCloseOnClick) {
      var shouldClose = shouldCloseOnClick(evt);
      if (shouldClose != null) {
        if (shouldClose) (0, _Functions.callIfPossible)(onOpenChange, (0, _SyntheticEvent2.default)(false));
        return;
      }
    }

    if (!closeOnOutsideClick || !this._isMounted) return;

    var clickTarget = evt.target;
    var tetherTarget = target || (0, _reactDom.findDOMNode)(this._popup);
    var contentEl = (0, _reactDom.findDOMNode)(this._content);

    // Ignore the click if it's within our Tether target
    if (tetherTarget && tetherTarget.contains(clickTarget)) return;

    // Ignore the click if it's within our popover container
    if (contentEl && (0, _EventHandlers.isClickWithinContainer)(evt, contentEl)) return;

    // Otherwise, trigger close
    (0, _Functions.callIfPossible)(onOpenChange, (0, _SyntheticEvent2.default)(false));
  },
  handleTetherUpdate: function handleTetherUpdate(event) {
    // Adjust our placement state to reflect Tether's response to a constraint
    var _props2 = this.props,
        autoPlacement = _props2.autoPlacement,
        onChangePlacement = _props2.onChangePlacement,
        placementProp = _props2.placement;
    var placementState = this.state.placement;

    var oldPlacement = getPlacement(placementProp, placementState);

    var newPlacementVert = autoPlacement === 'horiz' ? (0, _Placement.getVertPart)(oldPlacement) : event.targetAttachment.top;
    var newPlacementHoriz = autoPlacement === 'vert' ? (0, _Placement.getHorizPart)(oldPlacement) : event.targetAttachment.left;

    if (!newPlacementVert || !newPlacementHoriz) {
      // This indicates pinning, which we don't need to respond to
      return;
    }

    var newPlacement = null;
    if (newPlacementVert === 'center' || newPlacementVert === 'middle') {
      newPlacement = newPlacementHoriz;
    } else if (newPlacementHoriz === 'center' || newPlacementHoriz === 'middle') {
      // #1942
      newPlacement = newPlacementVert;
    } else {
      newPlacement = newPlacementVert + ' ' + newPlacementHoriz;
    }

    if (this.state.placement !== newPlacement) {
      this.setState({
        placement: newPlacement
      });
      (0, _Functions.callIfPossible)(onChangePlacement, { newPlacement: newPlacement });
    }
  },
  handleCloseComplete: function handleCloseComplete() {
    (0, _Functions.callIfPossible)(this.props.onCloseComplete);
    if (this._isMounted) {
      this.setState({ closeComplete: true });
    }
  },
  reposition: function reposition() {
    if (this._popup) {
      this._popup.repositionTether();
    }
  },
  contentRefCallback: function contentRefCallback(ref) {
    this._content = ref;
  },
  popupRefCallback: function popupRefCallback(ref) {
    this._popup = ref;
  },
  render: function render() {
    var _this3 = this;

    var _props3 = this.props,
        addTargetClasses = _props3.addTargetClasses,
        animateOnMount = _props3.animateOnMount,
        animateOnToggle = _props3.animateOnToggle,
        arrowSize = _props3.arrowSize,
        autoPlacement = _props3.autoPlacement,
        children = _props3.children,
        className = _props3.className,
        __closeOnOutsideClick = _props3.closeOnOutsideClick,
        __closeOnTargetLeave = _props3.closeOnTargetLeave,
        onFocusLeave = _props3.onFocusLeave,
        __onChangePlacement = _props3.onChangePlacement,
        onOpenChange = _props3.onOpenChange,
        __onCloseComplete = _props3.onCloseComplete,
        open = _props3.open,
        pinToConstraint = _props3.pinToConstraint,
        pinToOutOfBoundsTarget = _props3.pinToOutOfBoundsTarget,
        placementProp = _props3.placement,
        __shouldCloseOnClick = _props3.shouldCloseOnClick,
        target = _props3.target,
        targetAttachment = _props3.targetAttachment,
        use = _props3.use,
        zIndex = _props3.zIndex,
        _bodyElement = _props3._bodyElement,
        _distanceAdjustment = _props3._distanceAdjustment,
        _insetAdjustment = _props3._insetAdjustment,
        _useMutationObserver = _props3._useMutationObserver,
        rest = _objectWithoutProperties(_props3, ['addTargetClasses', 'animateOnMount', 'animateOnToggle', 'arrowSize', 'autoPlacement', 'children', 'className', 'closeOnOutsideClick', 'closeOnTargetLeave', 'onFocusLeave', 'onChangePlacement', 'onOpenChange', 'onCloseComplete', 'open', 'pinToConstraint', 'pinToOutOfBoundsTarget', 'placement', 'shouldCloseOnClick', 'target', 'targetAttachment', 'use', 'zIndex', '_bodyElement', '_distanceAdjustment', '_insetAdjustment', '_useMutationObserver']);

    var _state = this.state,
        closeComplete = _state.closeComplete,
        placementState = _state.placement;


    var computedArrowSize = getArrowSize(arrowSize, use);
    var computedAnimateOnToggle = getAnimateOnToggle(animateOnToggle, computedArrowSize);
    var computedArrowParams = _UIPopoverArrow2.default.ARROW_SIZES[computedArrowSize];
    var computedPlacement = getPlacement(placementProp, placementState);

    return _react2.default.createElement(
      _ModalTransitionContext.ModalTransitionContextConsumer,
      null,
      function (_ref) {
        var inModalTransition = _ref.transitioning;

        // `contentOpen` triggers open/close transitions
        var contentOpen = open && !inModalTransition;
        // `tetherOpen` determines whether the popover is in the DOM
        var tetherOpen = contentOpen || !closeComplete;

        var renderedContent = tetherOpen ? _react2.default.createElement(_UIPopoverContent2.default, _extends({}, rest, {
          animateOnMount: Boolean(animateOnMount && !_this3._isMounted || computedAnimateOnToggle && _this3._isMounted),
          animateOnToggle: computedAnimateOnToggle,
          arrowSize: computedArrowSize,
          className: className,
          'data-component-name': 'UIPopover',
          onCloseComplete: _this3.handleCloseComplete,
          open: contentOpen,
          placement: computedPlacement,
          ref: _this3.contentRefCallback,
          use: use,
          onOpenChange: onOpenChange
        })) : null;

        return _react2.default.createElement(
          _UIAbstractPopup2.default,
          {
            addTargetClasses: addTargetClasses,
            autoPlacement: autoPlacement,
            bodyElement: _bodyElement,
            center: computedArrowSize !== 'none',
            content: renderedContent,
            distance: computedArrowParams.distance + _distanceAdjustment,
            inset: computedArrowParams.inset + _insetAdjustment,
            onFocusLeave: onFocusLeave,
            onTetherUpdate: _this3.handleTetherUpdate,
            open: tetherOpen,
            pinToConstraint: pinToConstraint,
            pinToOutOfBoundsTarget: pinToOutOfBoundsTarget,
            placement: computedPlacement,
            ref: _this3.popupRefCallback,
            target: target,
            targetAttachment: targetAttachment,
            zIndex: zIndex,
            _useMutationObserver: _useMutationObserver
          },
          children
        );
      }
    );
  }
});

var UIControlledPopover = UIPopover;

exports.default = UIControlledPopover;
module.exports = exports['default'];